import apiServer from "../services";

const state = {
  classModuleRefresh: 1,
  resumeClassModuleRefresh: 1,
  stopClassModuleRefresh: 1,
};
const getters = {

};
const mutations = {
  Refresh_Class(state, number) {
    // debugger;
    state.classModuleRefresh = number;
  },
  Refresh_resumeClass(state, number) {
    state.resumeClassModuleRefresh = number;
  },
  Refresh_stopClass(state, number) {
    state.stopClassModuleRefresh = number;
  }
};
const actions = {
  refreshClass(context, number) {
    context.commit('Refresh_Class', number);
  },
  refreshResumeClass(context, number) {
    context.commit('Refresh_resumeClass', number);
  },
  RefreshstopClass(context, number) {
    context.commit('Refresh_stopClass', number);
  }

};


export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/mockEventSync.js